module.exports = __webpack_public_path__ + "img/沙漠球球1984x940.c9fd72f0.png";